import { OUT_OF_STOCK } from '@jouzen/ecom-components/v3/consts/stockStatus';
import type { RingFinish } from '@jouzen/ecom-components/v3/types/ringFinish';

import type { UseProductsInventory } from '@/app/[locale]/product/_hooks/useProductsInventory';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';
import type { RingStyle } from '@/app/types/ring';
import type { ListProduct } from '@/queries/Products';

import type { Ring } from '../_hooks/types';

const OR4_HANDLE_PARTIAL = 'or4';

interface FilterByInStockReturn {
  filteredStyleByInStock: Ring[] | undefined;
  filteredFinishByInStock: Ring[] | undefined;
}

interface FilterByInStockProps {
  productsData: ListProduct[] | undefined;
  getStyleStockStatus: UseProductsInventory['getStyleStockStatus'];
  getFinishStockStatus: UseProductsInventory['getFinishStockStatus'];
}

const filterByInStock = ({
  productsData,
  getStyleStockStatus,
  getFinishStockStatus,
}: FilterByInStockProps): FilterByInStockReturn => {
  const ringsData: ListProduct[] | undefined = productsData?.filter(
    (product: ListProduct) => product.isRing,
  );

  const gen3RingsData = ringsData?.filter(
    (product: ListProduct) => !product.handle.includes(OR4_HANDLE_PARTIAL),
  );

  const _ringsData = gen3RingsData;

  const rings: Ring[] | undefined = _ringsData?.map((product: ListProduct) => {
    // split at first hyphen only
    const [style, ...rest] = product.handle.split(/-(.*)/);

    const _style =
      style === OR4_HANDLE_PARTIAL
        ? RingStyleEnum.OuraRing4
        : (style as RingStyle);
    const _finish = rest.join('') as RingFinish;

    return { ...product, style: _style, finish: _finish };
  });

  const filteredStyleByInStock: Ring[] | undefined = rings?.filter((ring) => {
    if (
      !ring.style ||
      ring.style.includes('test') ||
      ring.style.includes('recurring')
    )
      return false;
    return (
      getStyleStockStatus({
        style: ring.style,
      }) !== OUT_OF_STOCK
    );
  });

  const filteredFinishByInStock: Ring[] | undefined =
    filteredStyleByInStock?.filter((ring) => {
      if (!ring.finish || !ring.style) return false;
      return (
        getFinishStockStatus({
          style: ring.style,
          finish: ring.finish,
        }) !== OUT_OF_STOCK
      );
    });

  return {
    filteredStyleByInStock,
    filteredFinishByInStock,
  };
};

export default filterByInStock;
